// extracted by mini-css-extract-plugin
export default {"wrapper":"NY_AD"};